import { render, staticRenderFns } from "./FaceManager.vue?vue&type=template&id=b66283a4"
import script from "./FaceManager.vue?vue&type=script&lang=js"
export * from "./FaceManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports